/**
 * EditIcon/index.js
 * desc: pencil edit icon
 * note: accessible icon-button (button + tooltip) by default; read-only renders a static glyph
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const EditIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="edit icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.edit.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M17.71 3.51727C18.1 3.90727 18.1 4.53727 17.71 4.92727L15.88 6.75727L12.13 3.00727L13.96 1.17727C14.35 0.787266 14.98 0.787266 15.37 1.17727L17.71 3.51727ZM0 18.8873V15.1373L11.06 4.07727L14.81 7.82727L3.75 18.8873H0Z" />
        </svg>
    </IconButton>
);


export default EditIcon;
